import { render, staticRenderFns } from "./shop_detail.vue?vue&type=template&id=24d0724f"
import script from "./shop_detail.vue?vue&type=script&lang=js"
export * from "./shop_detail.vue?vue&type=script&lang=js"
import style0 from "./shop_detail.vue?vue&type=style&index=0&id=24d0724f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports